module.exports = __webpack_public_path__ + "img/pro_one_1.754abcec.jpg";